import type { ChatBotChainsCollectionState } from './chat-bot-chains.reducer';
import type { CollectionsState } from '../collections-feature.reducer';

import { createSelector } from '@ngrx/store';
import { getQueryKey } from './chat-bot-chains.model';
import { CHAT_BOT_CHAINS_COLLECTION_FEATURE_KEY, chatBotChainsAdapter } from './chat-bot-chains.reducer';
import { collectionsState } from '../collections-state.selectors';

const { selectCollectionQueryItem, selectCollectionQueryStatuses } = chatBotChainsAdapter.getSelectors();

export const selectChatBotChainsState = createSelector(
    collectionsState,
    (state: CollectionsState): ChatBotChainsCollectionState => state[CHAT_BOT_CHAINS_COLLECTION_FEATURE_KEY]
);

export const selectChatBotChains = (messenger: string, botId: string) =>
    createSelector(selectChatBotChainsState, selectCollectionQueryItem(getQueryKey(messenger, botId)));

export const selectChatBotChainsStatuses = (messenger: string, botId: string) =>
    createSelector(selectChatBotChainsState, selectCollectionQueryStatuses(getQueryKey(messenger, botId)));
